import { render, staticRenderFns } from "./PriorityList.vue?vue&type=template&id=4464eae3&scoped=true&"
import script from "./PriorityList.vue?vue&type=script&lang=js&"
export * from "./PriorityList.vue?vue&type=script&lang=js&"
import style0 from "./PriorityList.vue?vue&type=style&index=0&id=4464eae3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4464eae3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VVirtualScroll})
